<template>
  <div>
    <section class="page-content special-title">
      <div class="row">
        <div class="col-md-12">
          <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
            <h1 v-if="getApplicantType === 'Ermunro' " class="font-weight-bold text-center">ER MUNRO PROFESSIONAL SERVICES AGREEMENT</h1>
            <h1 v-else class="font-weight-bold text-center">OREP PROFESSIONAL SERVICES AGREEMENT</h1>
          </article>
          <article class="input-section form-section">
            <div>
              <p v-if="getApplicantType==='Ermunro'" class="mb-3">
                This Professional Services Agreement & Broker Agreement (“Agreement”) is effective as of the date this agreement is signed,
                (“Effective Date”), by and between the undersigned (“Client”) and ER MUNRO- Organization of Real Estate Professionals Insurance
                Services, LLC (“Broker”). Under this Agreement, the parties agree to separate services to be provided by Broker to Client and related
                fees, as set forth herein.
              </p>
              <p v-else class="mb-3">
                This Professional Services Agreement & Broker Agreement (“Agreement”) is effective as of the date this agreement is signed,
                (“Effective Date”), by and between the undersigned (“Client”) and OREP- Organization of Real Estate Professionals Insurance
                Services, LLC (“Broker”). Under this Agreement, the parties agree to separate services to be provided by Broker to Client and related
                fees, as set forth herein.
              </p>
              <p class="mb-3">
                When applicable, Broker will make a reasonable search of the marketplace of insurers available to Broker and provide options to Client
                for the type of risk that Client wishes to insure based on the requirements and specifications provided by Client. Client acknowledges
                that no insurance coverage exists until accepted by the carrier(s) and that Broker is not obligated to change or renew any coverage
                without a written order. Client authorizes Broker to cancel any insurance policies if any premiums or Service Fees (defined below)
                remain unpaid to Broker. In addition to the Commission, Client acknowledges and agrees that Broker may receive additional
                compensation from insurers, finance companies, or other vendors for its professional services, which may be in a variety of forms and
                amounts.
              </p>
              <p class="mb-3">
                <u><strong>Scope of Services:</strong></u> Separate from the Commission, Broker will provide Client services, education, training and other value-add services
                (“Services”) in exchange for Client’s payment of the fees (“Service Fees”), as set forth in the below referenced Scope of Services. Client
                consents to the payment of the Service Fees. Client acknowledges and agrees that that the Services are separate from the Insurance
                Brokering and related Commissions, and provide valuable education, information and related services to Client. Client also
                acknowledges and agrees that the Service Fees are non-refundable and fully earned upon binding of the insurance policy, irrespective
                of whether the policy is later cancelled or non-renewed by Client or insurer. Client further acknowledges and agrees that the Service
                Fees are not part of the premium charged by any insurer, and are in addition to Commission paid by Client as well as any additional
                compensation Broker may receive from insurers for its professional services.
              </p>
              <p class="mb-3">
                <u><strong>General:</strong></u> This Agreement shall continue in full force until terminated by either party for any reason. The Service Fees are applicable as
                and to the fullest extent permissible in the applicable state/jurisdiction. If Broker adopts any enhancements to its Services during the
                term hereof that would otherwise increase the Services available without additional charge, such increased Services will apply to this
                Agreement at no extra charge to Client.
              </p>
              <p class="mb-3">
                Broker and Client agree to the terms and conditions set forth above and on the attached Scope of Services, and acknowledge receipt of
                a copy of this Agreement.
              </p>
            </div>
          </article>
          <article class="form-heading input-section form-section review-sign">
            <div class="row mb-3">
              <div class="col-md-12">
                <section class="notice-form mt-3">
                  <label class="notice-form-date">Client Signature:</label>
                  <input
                      type="text"
                      class="orep-text-input notice-input w-100"
                      name="clientSignature"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="ppiApplication.clientSignature"
                  >
                  <span
                      v-show="errors.has('clientSignature')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('clientSignature') | filterText }}</span>
                </section>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <section class="notice-form mt-3">
                  <label class="notice-form-date">Name :</label>
                  <input
                      type="text"
                      class="orep-text-input notice-input w-100"
                      name="signatureNameOfApplicant"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                      v-model="ppiApplication.nameOfApplicant"
                  >
                  <span
                      v-show="errors.has('signatureNameOfApplicant')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('signatureNameOfApplicant') | filterText }}</span>
                </section>
              </div>
              <div class="col-md-5 ml-auto">
                <section class="notice-form mt-3">
                  <label class="notice-form-date">Date:</label>
                  <input
                      type="date"
                      class="orep-text-input notice-input text-center w-100"
                      :value="formattedCurrentDate()"
                      disabled
                  >
                </section>
              </div>
            </div>
          </article>
          <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
            <div>
              <p class="font-weight-bold text-center mb-0">

                There is no Cost or Obligation to Obtain a Quote.  Your No-Obligation Quote on the Next Page.
              </p>
            </div>
            <br />
            <div>
              <p class="font-weight-bold text-center">
                PROFESSIONAL SERVICE AGREEMENT “SCOPE OF SERVICES”
              </p>
            </div>

          </article>
          <article class="input-section form-section">
            <div class="row table-border">
              <div class="col-md-8">
                <strong>Services:</strong>
                <ul>
                  <li>
                    Risk management and loss control information tailored to private investigators, including a free 8 hour CE class for PIs and guaranteed delivery of Working PI
                  </li>
                </ul>
              </div>
              <div class="col-md-4 d-flex flex-column table-left-border">
                <strong style="text-decoration: underline">Service / RPG Fee:</strong>
                <div class="d-flex flex-column justify-content-center flex-grow-1">
                  <strong class="text-decoration-none">Billed Annually at time insurance is bound: $30</strong>
                  <p v-if="getApplicantType==='Ermunro'">(Replaces $30 ER MUNRO fee of prior
                    years, where applicable.)</p>

                  <p v-else >(Replaces $30 OREP fee of prior
                    years, where applicable.)</p>

                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'ppi-application-3'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('ppi-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ppi-application-2')"></button>
              <button
                  class="pagination-dots"
                  @click="navigateToPrev('ppi-application-3')">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToPrev('ppi-application-4')">
              </button>
              <span class="pagination-dots pagination-current"></span>

            </article>
            <button
                class="next-btn mont spaced text-uppercase"
                @click="formSubmit()"
                :disabled="!state.pageFiveIsValid"
                :class="{submitDisabled: !state.pageFiveIsValid}">Submit</button>

          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Processing...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS, STATUS} from "../../utils/constants";

export default {
  name: "ppi-application-4",
  data() {
    return {
      loading: false
    };
  },
  computed: {
    getApplicantType() {
      var route = this.$route.path;
      var first = route.substring(0, route.lastIndexOf("/") + 1);
      if (first === '/portal/ppi-application-amba/' || this.ppiApplication.customer.partnerName === 'Mercer'){
        return 'Mercer';
      }else if (first === '/portal/ppi-application-realshield/' || this.ppiApplication.customer.partnerName === 'Realshield'){
        return 'Realshield';
      }
      else if (first === '/ermunro/ppi-application/' || first === '/ERMUNRO/ppi-application/' || this.ppiApplication.customer.partnerName === 'Ermunro'){
        return 'Ermunro';
      }
      else {
        return 'OREP';
      }
    },
    ppiApplication() {
      return this.$store.state.ppiApplication.ppiApplication;
    },
    state() {
      return this.$store.state.ppiApplication;
    },
    errorMsg() {
      return this.$store.state.ppiApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },
    next(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    checkServices(service) {
      return this.ppiApplication.applicantOrAssociateReportMode.includes(service);
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFiveIsValid = true;
          return;
        }
        this.state.pageFiveIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.ppiApplication.applicantPrincipleEsignatureDatetime).format('YYYY-MM-DD');
    },
    formSubmit() {
      this.loading = true;
      this.ppiApplication.status = STATUS.Submitted;
      this.ppiApplication.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('ppiApplication/createPpiApplication');
    }

  },


  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
      scrollTop: $('.page-content').offset().top
    }, 500);
  },

  components: {}
};
</script>

<style scoped>
strong {
  text-decoration: underline;
}
.form-inline > label {
  width: 82px;
  text-align: left;
}
.form-heading > p {
  font-size: 35px;
  width: 100%;
  text-align: center;
  margin: 0;
}
.form-errors,
.js-input-errors {
  display: block;
  text-transform: initial;
  font-size: 13px;
  width: 90%;
  margin: auto;
  position: relative;
  top: -29px;
}
fieldset {
  font-size: 12px;
}
.logo {
  width: 150px;
  height: 45px;
  object-fit: contain;
}
h6 {
  font-size: 14px;
}
h5 {
  font-size: 16px;
}
.company-info-content {
  padding: 10px 30px;
  border: 1px solid black;
}
.fs-subtitle {
  margin: 20px 0;
  border-bottom: 2px solid black;
}
table.oreptable {
  font-size: 14px;
  margin-left: auto;
  margin-right: auto;
}
.gen-inf {
  display: flex;
  background: #eee none repeat scroll 0 0;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 20px;
  margin-top: 20px;
  padding: 7px;
  text-align: left;
  height: 30px;
  border: 1px solid black;
}
.underline-value {
  margin-left: 10px;
  margin-right: 40px;
  border-bottom: 1px solid black;
  margin-bottom: 15px;
  font-weight: 700;
  font-size: 14px;
}
.table th, .table td {
  text-align: center;
  vertical-align: middle;
}
.table.ar td, .table.ar th {
  border-left: 1px solid #ddd !important;
  border-top: 1px solid #ddd !important;
  border-right: 1px solid #ddd !important;
}
.w-20 {
  width: 20%;
}
.blank_th {
  width: 210px;
}
.footer-company-info {
  background-color: yellow;
  border: 1px solid black;
  padding: 10px 20px 40px;
}
.form-check-input {
  position: relative;
  margin-left: 0;
}
.page-content p, .page-content li {
  font-size: 15px;
}
.p-56, .notice-list > li, .notice-info {
  padding-right: 56px;
}
</style>

